module.exports = __webpack_public_path__ + "assets/logo_tbm.c7b5907f9e5f31cba2622d1ad3fbe03c.png";


//////////////////
// WEBPACK FOOTER
// ./img/logo_tbm.png
// module id = 890
// module chunks = 0